import { PlanLimitConfigs, BillingCycleConfig } from "../common.ts";

export const COMPASS_DEFAULT_BILLING_CYCLE = "MONTHLY";
export const COMPASS_DEFAULT_UNIT_COUNT = 300;

export const COMPASS_MIN_ENTERPRISE_USER_COUNT = Infinity;

export const compassOfferingSkus = {
    free: "compass-free",
    standard: "compass-standard",
    premium: "compass-premium-sku"
} as const;

export const compassOfferingSkusArray = Object.values(compassOfferingSkus);

export const compassPlanLimitConfigs: PlanLimitConfigs[] = [
    {
        planName: "Free",
        offeringSku: compassOfferingSkus.free,
        recommendationLimit: 0,
        signupLimit: 3
    },
    {
        planName: "Standard",
        offeringSku: compassOfferingSkus.standard,
        recommendationLimit: 3,
        signupLimit: 35_000
    },
    {
        planName: "Premium",
        offeringSku: compassOfferingSkus.premium,
        recommendationLimit: 250,
        signupLimit: 35_000
    }
];

export const compassBillingCycleConfig: BillingCycleConfig = {
    monthly: true,
    annual: true
};
